// extracted by mini-css-extract-plugin
export default {"searchWrapper":"styles_searchWrapper__qxOHh","inputWrapper":"styles_inputWrapper__4Yt00","bgWrapper":"styles_bgWrapper__V4snk"};